import {Card, CardHeader, Dialog, IconButton, Tooltip} from '@mui/material'
import {SectorComercialViewDTO, SectorComercialViewDTOFields} from './types'
import {HttpSectorComercialABM} from './api'
import {GridActionsCellItem} from '@mui/x-data-grid'
import {useState} from 'react'
import EditIcon from '@mui/icons-material/Edit'
import EditSectorComercial from './EditSectorComercial'
import {ItecDataGrid, ItecGridColsDef as GridColsDef, useItecDataGrid} from 'src/lib/itaptec/datagrid/src'
import CachedIcon from '@mui/icons-material/Cached'
import Chip from 'src/@core/components/mui/chip'
import {WrapperTable} from '../components'
import {CountryAvatar} from "../../../../../components/icons/CountryAvatar";

function TableSectoresComerciales() {
  const [selectedSectorComercial, setSelectedSectorComercial] = useState<SectorComercialViewDTO>()

  const columnas: GridColsDef<SectorComercialViewDTO>[] = [
    {
      headerName: 'Nombre',
      field: SectorComercialViewDTOFields.Nombre,
      flex: 1
    },
    {
      headerName: 'País',
      field: SectorComercialViewDTOFields.NombrePais,
      flex: 1,
      renderCell: ({row: sector}) => {
        return (
          <Chip
            label={sector[SectorComercialViewDTOFields.NombrePais]}
            size='small'
            skin='light'
            variant='outlined'
            avatar={<CountryAvatar countryCode={sector[SectorComercialViewDTOFields.CodPais]}/>}
          />
        )
      }
    },
    {
      field: 'actions',
      type: 'actions',
      getActions: ({row}) => [
        <GridActionsCellItem
          key={1}
          onClick={() => {
            setSelectedSectorComercial(row)
          }}
          icon={
            <Tooltip title='Editar'>
              <EditIcon color='info'/>
            </Tooltip>
          }
          label='Editar'
          showInMenu={true}
        />
      ]
    }
  ]

  const {
    datagridProps,
    control: {
      query: {refetch}
    }
  } = useItecDataGrid({
    pagination: false,
    columns: columnas,
    getEntities: HttpSectorComercialABM.getSectoresComerciales,
    density: 'compact'
  })

  // useEffect(() => {
  //     HttpSectorComercialABM.getSectoresComerciales().then(setSectores)
  // }, [])

  return (
    <WrapperTable>
      <Card>
        <CardHeader
          title='Administración de sectores comerciales'
          action={
            <IconButton disabled={datagridProps.loading} onClick={() => refetch()}>
              <CachedIcon/>
            </IconButton>
          }
        />
        <ItecDataGrid {...datagridProps} />
      </Card>
      <>
        <Dialog
          open={!!selectedSectorComercial}
          fullWidth
          maxWidth='lg'
          keepMounted={false}
          sx={{maxHeight: '100%'}}
        >
          {selectedSectorComercial && (
            <EditSectorComercial
              onClose={() => {
                setSelectedSectorComercial(undefined)
              }}
              sector={selectedSectorComercial}
            />
          )}
        </Dialog>
      </>
    </WrapperTable>
  )
}

export default TableSectoresComerciales
